export const tcIndexFieldsMapping = new Map([
    ['index.name', { placeHolder: 'Index name' }],
    ['vessel.imoNumber', { placeHolder: 'Imo number' }],
    ['vessel.name', { placeHolder: 'Name' }],
    ['typeByPurpose', { placeHolder: 'Type by Purpose' }],
    ['vesselDwtGroup.name', { placeHolder: 'Dwt group' }],
    ['vesselDwtGroup.min', { placeHolder: 'Dwt group (min)' }],
    ['vesselDwtGroup.max', { placeHolder: 'Dwt group (max)' }],
    ['placeFrom.name', { placeHolder: 'Place from' }],
    ['regionFrom.name', { placeHolder: 'Region from' }],
    ['regionFrom.mainRegion', { placeHolder: 'Region from (main region)', isBoolean: true }],
    ['regionFrom.isInBalticIndex', { placeHolder: 'Region from (baltic index)', isBoolean: true }],
    ['placeTo.name', { placeHolder: 'Place to' }],
    ['regionTo.name', { placeHolder: 'Region to' }],
    ['regionTo.mainRegion', { placeHolder: 'Region to (main region)', isBoolean: true }],
    ['regionTo.isInBalticIndex', { placeHolder: 'Region to (baltic index)', isBoolean: true }],
    ['lay', { placeHolder: 'Lay' }],
    ['can', { placeHolder: 'Can' }],
    ['via.name', { placeHolder: 'Via' }],
    ['roundTrip', { placeHolder: 'Round trip', isBoolean: true }],
    ['clean', { placeHolder: 'Clean', isBoolean: true }],
    ['duration', { placeHolder: 'Duration' }],
    ['balastBonus', { placeHolder: 'Balast bonus' }],
    ['intake', { placeHolder: 'Intake' }],
    ['tcIndex', { placeHolder: 'Tc Index' }],
    // ['rejected', { placeHolder: 'Rejected' }],
    ['endAt', { placeHolder: 'End at' }],
    ['lastUpdate.user.email', { placeHolder: 'Last update by' }],
    ['lastUpdate.date', { placeHolder: 'Last update' }],
    ['confirmed', { placeHolder: 'Confirmed', isBoolean: true }],
]);



// WEBPACK FOOTER //
// ./app/constants/misc.js